import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { versions, versionNotes } from "@/mocks/versions";

export default function Versions() {
  const [activeId, setActiveId] = useState(versions[0].id);
  const active = versions.find((v) => v.id === activeId) ?? versions[0];

  return (
    <section id="versions" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="Changelog"
          title="版本更新日志与安装包信息"
          desc="选择版本查看具体改动。下载前可对照版本号与安装包体积，确认获取到的是最新且完整的客户端。"
        />

        <div className="max-w-5xl mx-auto mt-10 grid grid-cols-1 lg:grid-cols-[280px_1fr] gap-6">
          <div className="flex lg:flex-col gap-2 overflow-x-auto lg:overflow-visible pb-2 lg:pb-0">
            {versions.map((v) => (
              <button
                key={v.id}
                type="button"
                onClick={() => setActiveId(v.id)}
                className={`shrink-0 lg:shrink text-left px-4 py-3 rounded-lg border cursor-pointer transition-colors ${
                  activeId === v.id
                    ? "bg-primary-500 border-primary-500 text-background-50"
                    : "bg-background-100 border-background-200 text-foreground-800 hover:border-primary-300"
                }`}
              >
                <div className="flex items-center gap-2">
                  <span className="font-heading text-base font-bold whitespace-nowrap">
                    {v.version}
                  </span>
                  {activeId === v.id && (
                    <i className="ri-checkbox-circle-fill text-sm"></i>
                  )}
                </div>
                <span
                  className={`block text-xs mt-1 whitespace-nowrap ${
                    activeId === v.id ? "text-background-100" : "text-foreground-500"
                  }`}
                >
                  {v.date}
                </span>
              </button>
            ))}
          </div>

          <div className="bg-background-100 border border-background-200 rounded-xl p-6">
            <div className="flex items-center flex-wrap gap-3">
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                {active.version}
              </h3>
              <span className="text-xs text-accent-700 bg-accent-100 px-3 py-1 rounded-full font-label">
                {active.tag}
              </span>
              <span className="text-xs text-foreground-500 font-label ml-auto">
                发布于 {active.date}
              </span>
            </div>
            <p className="mt-2 text-xs text-foreground-500 inline-flex items-center gap-1.5">
              <i className="ri-scales-3-line"></i>
              {active.size}
            </p>

            <ul className="mt-5 flex flex-col gap-3">
              {active.changes.map((change, index) => (
                <li key={index} className="flex gap-3 text-sm text-foreground-700 leading-relaxed">
                  <i className="ri-arrow-right-s-line text-primary-500 shrink-0 mt-0.5"></i>
                  {change}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="max-w-5xl mx-auto mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
          {versionNotes.map((note) => (
            <div
              key={note.id}
              className="bg-secondary-50 border border-secondary-200 rounded-lg p-5"
            >
              <div className="w-10 h-10 rounded-lg bg-secondary-100 text-secondary-700 flex items-center justify-center">
                <i className={`${note.icon} text-lg`}></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-950">{note.title}</h3>
              <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed">{note.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}